/* Slock Master — v11 header behavior: mega-menu (hover/click), mobile toggle, scroll show/hide.
   Ported from version-11. closeMegaMenu / toggleMobileMenu are global (used by inline onclick). */
(function () {
  var megaMenuOpen = false;
  var megaCloseTimer = null;

  function activateMenuCat(cat) {
    document.querySelectorAll('.menu-sub').forEach(function (s) { s.classList.add('hidden'); });
    var target = document.querySelector('.menu-sub[data-menu-cat="' + cat + '"]');
    if (target) target.classList.remove('hidden');
    document.querySelectorAll('.menu-cat').forEach(function (b) {
      var on = b.dataset.menuCat === cat;
      b.classList.toggle('active', on);
      b.classList.toggle('border-sienna', on);
      b.classList.toggle('border-transparent', !on);
    });
  }

  function openMegaMenu(cat) {
    var mega = document.getElementById('mega-menu');
    var nav = document.getElementById('site-nav');
    if (!mega || !nav) return;
    activateMenuCat(cat);
    mega.classList.add('open');
    nav.classList.add('mega-open');
    megaMenuOpen = true;
    document.querySelectorAll('.menu-tab').forEach(function (t) {
      t.classList.toggle('active', t.dataset.menuCat === cat);
    });
  }

  function closeMegaMenu() {
    var mega = document.getElementById('mega-menu');
    var nav = document.getElementById('site-nav');
    if (!mega || !nav) return;
    mega.classList.remove('open');
    nav.classList.remove('mega-open');
    megaMenuOpen = false;
    document.querySelectorAll('.menu-tab').forEach(function (t) { t.classList.remove('active'); });
    var mi = document.getElementById('menu-icon');
    var ci = document.getElementById('close-icon');
    if (mi) mi.classList.remove('hidden');
    if (ci) ci.classList.add('hidden');
  }
  window.closeMegaMenu = closeMegaMenu;

  function toggleMobileMenu() {
    var menuIcon = document.getElementById('menu-icon');
    var closeIcon = document.getElementById('close-icon');
    if (megaMenuOpen) {
      closeMegaMenu();
    } else {
      openMegaMenu('shop');
      if (menuIcon) menuIcon.classList.add('hidden');
      if (closeIcon) closeIcon.classList.remove('hidden');
    }
  }
  window.toggleMobileMenu = toggleMobileMenu;

  function initDesktopMenuTabs() {
    document.querySelectorAll('.menu-tab').forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        if (megaCloseTimer) { clearTimeout(megaCloseTimer); megaCloseTimer = null; }
        openMegaMenu(tab.dataset.menuCat);
      });
      tab.addEventListener('click', function () {
        if (megaMenuOpen && tab.classList.contains('active')) { closeMegaMenu(); }
        else { openMegaMenu(tab.dataset.menuCat); }
      });
    });
    var nav = document.getElementById('site-nav');
    if (nav) {
      nav.addEventListener('mouseleave', function () { megaCloseTimer = setTimeout(closeMegaMenu, 200); });
      nav.addEventListener('mouseenter', function () { if (megaCloseTimer) { clearTimeout(megaCloseTimer); megaCloseTimer = null; } });
    }
  }

  function initMobileMenuCats() {
    document.querySelectorAll('.menu-cat').forEach(function (btn) {
      var cat = btn.dataset.menuCat;
      btn.addEventListener('click', function (e) { e.preventDefault(); activateMenuCat(cat); });
    });
  }

  /* Header: transparent over the homepage hero, solid after; hide on scroll-down / show on scroll-up. */
  function initScroll() {
    var nav = document.getElementById('site-nav');
    var hero = document.getElementById('hero');
    if (!nav) return;
    var lastY = window.scrollY || 0;
    function update() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (hero && y < (hero.offsetHeight - 90)) {
        nav.classList.add('nav-transparent'); nav.classList.remove('nav-solid');
      } else {
        nav.classList.remove('nav-transparent'); nav.classList.add('nav-solid');
      }
      // Per client request: the header stays pinned and never hides on scroll-down.
      // Only the transparent↔solid swap above runs on scroll; .nav-hidden is never applied.
      nav.classList.remove('nav-hidden');
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function init() { initDesktopMenuTabs(); initMobileMenuCats(); initScroll(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
